import { Route, Switch, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { colorBackgroundBody } from '@/utils/palette';
import { paddingLeft } from '@/utils/directions';
import styled from 'styled-components';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/shared/components/Button';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import DisponibilidadeMain from '../Programacao/Disponibilidade/index';
import DetalhesDisponibilidade from '../Programacao/Detalhes/index';
import CadastrosDisponibilidadeMain from '../Programacao/Cadastro/index';
import LogIn from '../LogIn/index';
import PrivateRoute from './PrivateRoute';
import NotFound from '../../containers/DefaultPage/404/index';

const Pages = () => (
  <Switch>
    <Route path="/pages/programacao/disponibilidade" component={DisponibilidadeMain} />
    <Route path="/pages/programacao/criardisponibilidade" component={CadastrosDisponibilidadeMain} />
    <Route path="/pages/programacao/detalhesdisponibilidade/personalizado/:id" component={DetalhesDisponibilidade} />
    <Route path="/pages/programacao/detalhesdisponibilidade/:id" component={DetalhesDisponibilidade} />
    <Route component={NotFound} />
  </Switch>
);

const WrappedRoutes = () => {
  const location = useLocation();
  const { user } = useAuth();
  const isPersonalizado = location.pathname.includes('/detalhesdisponibilidade/personalizado/');
  
  // Usuário externo só pode acessar telas personalizadas
  if (user?.isExternalUser && !isPersonalizado) {
    return (
      <div style={{ 
        padding: '50px', 
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px'
        }}>
          <h2 style={{ color: '#dc3545', marginBottom: '20px' }}>🚫 Acesso Restrito</h2>
          <p style={{ marginBottom: '15px', color: '#6c757d' }}>
            Você está acessando como usuário externo e não tem permissão para esta área.
          </p>
          <p style={{ marginBottom: '25px', color: '#6c757d' }}>
            Para acessar todas as funcionalidades, faça login com sua conta @transben.com.br
          </p>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button 
              variant="primary" 
              onClick={() => window.location.href = '/log_in'}
              style={{ minWidth: '120px' }}
            >
              Fazer Login
            </Button>
            <Button 
              variant="secondary" 
              onClick={() => window.close()}
              style={{ minWidth: '120px' }}
            >
              Fechar
            </Button>
          </div>
        </div>
      </div>
    );
  }
  
  const Container = isPersonalizado ? ContainerFullPage : ContainerWithLayout;

  return (
    <div>
      {!isPersonalizado && <Layout />}
      <Container>
        <Pages />
      </Container>
    </div>
  );
};

const Router = () => {
  const location = useLocation();
  const { loginWithToken } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encryptedToken = params.get('tk');

    if (encryptedToken) {
      // Verifica se já processou este token para evitar loops
      const processedToken = localStorage.getItem('processedToken');
      if (processedToken === encryptedToken) {
        console.log('🔄 Token já foi processado, pulando...');
        return;
      }

      console.log('🔄 Processando novo token...');
      const success = loginWithToken(encryptedToken);
      if (success) {
        // Marca o token como processado
        localStorage.setItem('processedToken', encryptedToken);
        // Remove o token da URL após processá-lo
        const cleanUrl = location.pathname;
        window.history.replaceState({}, '', cleanUrl);
      }
    }
  }, [location.pathname, location.search]);

  return (
    <MainWrapper>
      <main>
        <Switch>
          <Route exact path={['/', '/log_in']} component={LogIn} />
          <PrivateRoute path="/pages" component={WrappedRoutes} />
          <Route component={NotFound} />
        </Switch>
      </main>
    </MainWrapper>
  );
};

export default Router;

// region STYLES

const ContainerWithLayout = styled.div`
  padding-top: 90px;
  min-height: 100vh;
  transition: padding-left 0.3s;
  background: ${colorBackgroundBody};
  ${paddingLeft}: 0;

  @media screen and (min-width: 576px) {
    ${paddingLeft}: 250px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 150px;
  }
`;

const ContainerFullPage = styled.div`
  padding: 0;
  margin: 0;
  min-height: 100vh;
  background: ${colorBackgroundBody};

  padding-top: 100px;

  @media screen and (max-width: 576px) {
    margin-top: 16px;
  }
`;
